export const config1 = {
  API_HOST: "https://www.momkidcare.com"
  // API_HOST: "https://dev.momkidcare.com"
  // API_HOST: "http://localhost:3000"
  //API_HOST: "http://8496fe44.ngrok.io"
  // API_HOST: "http://192.168.0.114:3000"
};
